import { z } from 'zod'

/* Generic Success Response */

export interface SuccessResponseWithoutPayload {
  succeeded: true
}

/* Generic Error Response */

/**
 * Generic wrapper to respond on failed API call ('ErrorResponse' backend API data type).
 */
export interface FailedResponse {
  succeeded: false
  errStatusCode: number
  errorKey?: string
  message?: string
}

/**
 * API error response schema, for errors with body ('ErrorResponse' backend API data type).
 */
export const ErrorResponseSchema = z.object({
  key: z.string(),
  message: z.string()
})

/* Generic File download Response */

/**
 * Success response  format for API function returning file content.
 */
export interface DownloadFileSuccessResponse {
  succeeded: true
  payload: {
    content: string
  }
}

/**
 * Response format for API-function returning file content.
 */
export type DownloadFileResponse = DownloadFileSuccessResponse | FailedResponse

/**
 * Date range (epoch seconds).
 */
export interface DateRange {
  startDate: number
  endDate: number
}
